import React from 'react';
import { node, string, number, bool, func } from 'prop-types'; // Base Modal from https://github.com/pradel/react-responsive-modal

import { Modal as ReactResponsiveModal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import './styles/modal.scss'; // Imported subcomponents & styled components

import { StyledInnerWrapper } from './styles/styled';
import ModalIcon from './ModalIcon';
import ModalTitle from './ModalTitle';
import ModalDescription from './ModalDescription';
import ModalButton from './ModalButton';

var Modal = function Modal(_ref) {
  var children = _ref.children,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      dataAnalyticsId = _ref.dataAnalyticsId,
      _ref$modalOpen = _ref.modalOpen,
      modalOpen = _ref$modalOpen === void 0 ? false : _ref$modalOpen,
      setModalOpen = _ref.setModalOpen,
      _ref$animationDuratio = _ref.animationDuration,
      animationDuration = _ref$animationDuratio === void 0 ? 600 : _ref$animationDuratio,
      _ref$closeOnOverlayCl = _ref.closeOnOverlayClick,
      closeOnOverlayClick = _ref$closeOnOverlayCl === void 0 ? false : _ref$closeOnOverlayCl,
      closeOnEsc = _ref.closeOnEsc,
      _ref$customOverlayCla = _ref.customOverlayClass,
      customOverlayClass = _ref$customOverlayCla === void 0 ? 'customOverlay' : _ref$customOverlayCla,
      _ref$customModalClass = _ref.customModalClass,
      customModalClass = _ref$customModalClass === void 0 ? 'customModal' : _ref$customModalClass;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactResponsiveModal, {
    open: modalOpen,
    modalId: "sharp-modal-1"
    /* istanbul ignore next */
    ,
    onClose: function onClose() {
      return setModalOpen(false);
    },
    showCloseIcon: false,
    animationDuration: animationDuration,
    center: true,
    closeOnEsc: closeOnEsc,
    closeOnOverlayClick: closeOnOverlayClick,
    classNames: {
      overlay: customOverlayClass,
      modal: customModalClass
    }
  }, /*#__PURE__*/React.createElement(StyledInnerWrapper, {
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "scl-modal-wrapper"
  }, children)));
};

Modal.Icon = ModalIcon;
Modal.Title = ModalTitle;
Modal.Description = ModalDescription;
Modal.Button = ModalButton;
Modal.Icon.displayName = 'Modal.Icon';
Modal.Title.displayName = 'Modal.Title';
Modal.Description.displayName = 'Modal.Description';
Modal.Button.displayName = 'Modal.Button'; // For any additional props needed to expose for our Sharp Modal component, please refer to the ReactResponsiveModal: https://react-responsive-modal.leopradel.com/#props

Modal.propTypes = {
  /**
   Optional: sets the animation duration for the modal instance
  */
  animationDuration: number,

  /**
   Optional: specific data-analytics-label for type of modal
  */
  dataAnalyticsLabel: string,

  /**
   Required: specific data-analytics-id for type of modal
  */
  dataAnalyticsId: string.isRequired,

  /**
   Optional: Set modal open state from the outside
  */
  modalOpen: bool,

  /**
   Optional: Callback fn passed to modal - outer context controls the state of modalOpen
  */
  setModalOpen: func,

  /**
   Optional: Is the modal closable when user clicks on overlay.
  */
  closeOnOverlayClick: bool,

  /**
   Optional: Is the modal closable when user press esc key.
  */
  closeOnEsc: bool,

  /**
   Optional: The name of the css class assigned to the overlay element in the modal.
  */
  customOverlayClass: string,

  /**
    Optional: The name of the css class assigned to the main container element in the modal.
   */
  customModalClass: string,

  /**
   Everything included between opening and closing tags when invoking component
  */
  children: node.isRequired
};
export default Modal;